import { createGlobalStyle } from 'styled-components';
 
const GlobalStyles = createGlobalStyle`
  body {
    font-family: 'OpenSans-Regular', Helvetica, Sans-Serif;
    box-sizing: border-box;
  }
`;
 
export default GlobalStyles;